export default __webpack_public_path__ + "0b2d6249bd6a8c58e971a3dd71b7a29a.svg";